import { useTranslation } from 'next-i18next'
// Component Based on https://www.npmjs.com/package/react-number-format

// Libs
import styled, { css } from 'styled-components'
import NumberFormat, { NumberFormatProps } from 'react-number-format'

// Comps
import { colors, mobileScreen, fontWeights } from '../../utils'

// Styles
const Container = styled.span`
  & input {
    border: 2px solid #f1f2f5;
    border-radius: 6px;
    box-sizing: border-box;
    height: 45px;
    width: 150px;
    padding: 10px;

    &:focus {
      border-color: ${colors.washedPurple};
      border-width: 4px;
      outline: none;
    }

    &:disabled {
      color: ${colors.grey};
    }

    &,
    * {
      color: ${colors.offBlack};
      font-weight: ${fontWeights.medium};
      font-size: 16px;
      letter-spacing: -0.6px;
      line-height: 140%;
    }
  }
`

export const MoneyInput: React.FC<NumberFormatProps> = (props) => {
  const { t } = useTranslation('common')

  // props
  const { placeholder, thousandSeparator, prefix } = props

  // ..
  return (
    <Container>
      <NumberFormat
        {...props}
        placeholder={placeholder || '$0.00'}
        displayType="input"
        thousandSeparator={thousandSeparator || true}
        prefix={prefix || '$'}
        decimalScale={2}
        fixedDecimalScale={true}
        allowNegative={false}
      />
    </Container>
  )
}
